import { Link, useLocation } from 'react-router-dom';

const PreservingLink = ({ children, to, ...props }: any) => {
  const { search } = useLocation();

  return (
    <Link to={to + search} {...props}>
      {children}
    </Link>
  );
};

export default PreservingLink;